const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/crm/contacts/lists/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFilterConfig } from '@/Components/filterbar';
import { requireUserPostCaps } from '@/Router';
import { type CrmList_Pagination_Fragment$key, type CrmList_Query, CrmListsQuery } from '@/graphql/queries/CrmList.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { usePaginationFragment } from '@/graphql/relay.utils';
import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
const CrmListFilterConfig = createFilterConfig({
  routeId: '/dash/crm/contacts/lists/',
  options: {
    restoreOnMount: true
  }
}, {
  search: true,
  visibility: true,
  author: true
});
type RelayData = ReturnType<typeof usePaginationFragment<CrmList_Query, CrmList_Pagination_Fragment$key>>;
type CrmListsProps = {
  isFallback?: boolean;
} & Partial<RelayData>;
export const Route = createFileRoute('/dash/crm/contacts/lists/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: CrmListFilterConfig.filterSearchValidator,
  beforeLoad: () => {
    requireUserPostCaps('form', 'read_post', {
      to: '/dash/crm'
    });
  },
  loader() {
    return loadQuery<CrmList_Query>(RelayEnvironment, CrmListsQuery, {}, {
      fetchPolicy: 'store-or-network'
    });
  }
});